import { VisitPriority, VisitPriorityOrder, VisitState } from '../../../types/visit';
import { deriveSortName } from '../../tables/utils';
import { getUnifiedStateIndex } from '../../unifiedVisits/utils';

export namespace VisitColumns {
    export const createCliniciansSortKey = (
        appointments: { clinician: { firstName: string } | null }[],
    ) => {
        return deriveSortName({
            objs: appointments,
            getKey: (appointment) => appointment.clinician?.firstName,
        });
    };

    export const createPrioritySortIndex = (priority: VisitPriority) => {
        return VisitPriorityOrder[priority];
    };

    export const priorityColumnOptions = {
        setCellProps() {
            return {
                sx: {
                    width: '50px',
                },
            };
        },
        sortDescFirst: true,
    };

    export const createServicesSortKey = (
        appointmentServices: { services: { name: string }[] }[],
    ) => {
        return deriveSortName({
            objs: appointmentServices,
            getKey: (appointmentService) =>
                deriveSortName({
                    objs: appointmentService.services,
                    getKey: (service) => service.name,
                }),
        });
    };

    export const createUnifiedStateIndex = (visitState: VisitState) => {
        return getUnifiedStateIndex({
            visitState,
        });
    };
}
